import CoreTransaction from 'core/js/pages/municipality-data/balance/tsc/_tsc_media_panel/_transaction'
import template from './_transaction.pug'

export default {
  extends: CoreTransaction,
  template: template(),
  
  computed: {
    originZone() {
      return this.transaction.node_from_name || null
    },

    destinationZone() {
      return this.transaction.node_to_name || null
    },

    traveledKilometers() {
      const value = Number(this.transaction.kilometers_traveled)

      if (!Number.isFinite(value) || value <= 0) return null

      return `${value.toFixed(2)} km`
    },

    shouldShowZoneInfo() {
      return false
    }
  }
}